import { SxProps, Theme } from '@mui/material';
import { useUser } from '../../lib/auth-client';
import { BasePageLayout } from './BasePageLayout';

interface BaseEntityPageProps {
	/**
	 * Content component that receives isAdmin and canEdit props
	 */
	ContentComponent: React.ComponentType<{ isAdmin: boolean; canEdit: boolean }>;
	/**
	 * Additional props to pass to the content component
	 */
	contentProps?: Record<string, unknown>;
	/**
	 * Custom styles for the page layout
	 */
	sx?: SxProps<Theme>;
}

/**
 * Base page component for entity management pages.
 * Handles user authentication, admin role checking, and provides consistent layout.
 * Used by entity pages like Faculties, Majors, Provinces, etc.
 */
export function BaseEntityPage({
	ContentComponent,
	contentProps = {},
	sx
}: BaseEntityPageProps) {
	const { user } = useUser();
	const isAdmin = user?.role === 'admin';
	const isManager = user?.role === 'manager';
	const canEdit = isAdmin || (isManager && user?.writable === true);

	return (
		<BasePageLayout sx={sx}>
			<ContentComponent isAdmin={isAdmin} canEdit={canEdit} {...contentProps} />
		</BasePageLayout>
	);
}